// V2 Table - Re-export from seeds-react-table for optimal tree shaking
export { default as TableV2 } from "@sproutsocial/seeds-react-table/v2";

// Explicit type exports
export type {
  TableV2Props,
  ColumnHeader,
  RowData,
} from "@sproutsocial/seeds-react-table/v2";

// Explicit style exports
export * from "@sproutsocial/seeds-react-table/v2";
